var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.social.length)?_c('div',{staticClass:"d-flex social-widget"},_vm._l((_vm.social),function(ref,keySocial){
var link = ref.link;
var icon = ref.icon;
return _c('v-btn',{key:keySocial,staticClass:"mr-1 d-flex",attrs:{"href":link,"target":"blank","width":"40px","height":"40px","icon":""}},[_c('v-icon',{attrs:{"color":"white","size":"20"}},[_vm._v(" "+_vm._s(icon)+" ")])],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }